// extracted by mini-css-extract-plugin
export default {"container":"BarcodeScanner_container__eYnhn","camera":"BarcodeScanner_camera__dW5Vt"};